import { createSelector } from "@reduxjs/toolkit";
import { SET_AVAILABLE_DEVICES_WORKER, SET_CHECK_SAVED_ALBUMS_CHANGES_WORKER, SET_DEACTIVATE_SHUFFLE_MODE_WORKER, SET_TOO_MANY_REQUESTS_COOLDOWN_WORKER, SET_UPDATE_PLAYBACK_WORKER, SET_WORKERS_RUNNING } from "../actions/workersActions";

export const areWorkersRunning = createSelector(
    state => state.workersState,
    workersState => workersState.running
);

export const getUpdatePlaybackWorker = createSelector(
    state => state.workersState,
    workersState => workersState.updatePlayback
);

export const getCheckSavedAlbumsChangesWorker = createSelector(
    state => state.workersState,
    workersState => workersState.checkSavedAlbumsChanges
);

export const getDeactivateShuffleModeWorker = createSelector(
    state => state.workersState,
    workersState => workersState.deactiveShuffleMode
);

export const getAvailableDevicesWorker = createSelector(
    state => state.workersState,
    workersState => workersState.availableDevices
);

export const getTooManyRequestsCooldownWorker = createSelector(
    state => state.workersState,
    workersState => workersState.tooManyRequestsCooldown
);

const INITIAL_STATE = {
    running: false,
    updatePlayback: undefined,
    checkSavedAlbumsChanges: undefined,
    deactiveShuffleMode: undefined,
    availableDevices: undefined,
    tooManyRequestsCooldown: undefined
};

export const workersState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_WORKERS_RUNNING:
            return {...state, running: action.payload};
        case SET_UPDATE_PLAYBACK_WORKER:
            return {...state, updatePlayback: action.payload};
        case SET_CHECK_SAVED_ALBUMS_CHANGES_WORKER:
            return {...state, checkSavedAlbumsChanges: action.payload};
        case SET_DEACTIVATE_SHUFFLE_MODE_WORKER:
            return {...state, deactiveShuffleMode: action.payload};
        case SET_AVAILABLE_DEVICES_WORKER:
            return {...state, availableDevices: action.payload};
        case SET_TOO_MANY_REQUESTS_COOLDOWN_WORKER:
            return {...state, tooManyRequestsCooldown: action.payload};
        default:
            return state;
    }
}